import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
const baseAPIUrl = process.env.REACT_APP_API_BASE_URL;

const LifeAtTIGPSSection = () => {
    const { school_slug } = useParams();

    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    /* ---------------- SECTION STATE ---------------- */

    const [form, setForm] = useState({
        heading: "",
        intro_paragraph: "",
    });

    /* ---------------- BLOCKS   ---------------- */
    const [blocks, setBlocks] = useState([
        { block_heading: "", block_paragraph: "", block_image: null, block_image_previw: null, existing_image: null, removed: false },
    ]);


    /* ---------------- FETCH DATA ---------------- */
    useEffect(() => {
        fetchContent();
    }, [school_slug]);

    const fetchContent = async () => {
        try {
            const res = await axios.get(
                `${baseAPIUrl}admin/life_at_tigps/get_life_at_tigps_content/${school_slug}`,
                { withCredentials: true }
            );

            if (res.data.status === 1 && res.data.data) {
                const { section, blocks } = res.data.data;

                /* ---------- SECTION ---------- */
                if (section) {
                    setForm({
                        heading: section.heading || "",
                        intro_paragraph: section.intro_paragraph || ""
                    });
                }
                /* ---------- BLOCKS ---------- */
                if (blocks && blocks.length > 0) {
                    setBlocks(
                        blocks.map(item => ({
                            block_heading: item.block_heading || "",
                            block_paragraph: item.block_paragraph || "",
                            block_image: null, // file will be chosen again if updated
                            block_image_previw: item.block_image
                                ? `${baseAPIUrl}assets/images/life_at_tigps/${item.block_image}?t=${Date.now()}`
                                : null,
                            existing_image: item.block_image || null,
                            removed: false
                        }))
                    );
                }

            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    /* HANDLERS */
    const updateBlockHeading = (index, value) => {
        setBlocks(prev => {
            const updated = [...prev];
            updated[index].block_heading = value;
            return updated;
        });
    };

    const updateBlockParagraph = (index, value) => {
        setBlocks(prev => {
            const updated = [...prev];
            updated[index].block_paragraph = value;
            return updated;
        });
    };

    const updateBlockImage = (index, file) => {
        setBlocks(prev => {
            const updated = [...prev];
            updated[index].block_image = file;
            updated[index].block_image_previw = URL.createObjectURL(file);
            return updated;
        });
    };

    const addBlock = () => {
        setBlocks(prev => [
            ...prev,
            { block_heading: "", block_image: null, block_image_previw: null }
        ]);
    };

    const removeBlock = (index) => {
        setBlocks(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                removed: true
            };
            return updated;
        });
    };

    /* ---------------- Submit ---------------- */
    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage("");

        try {
            setLoading(true);
            const formData = new FormData();
            /* ---------- BASIC DATA ---------- */
            formData.append("school_slug", school_slug);
            formData.append("section", JSON.stringify({
                heading: form.heading || "",
                intro_paragraph: form.intro_paragraph || ""
            }));

            /* ---------- BLOCK DATA (TEXT ONLY) ---------- */
            const cleanBlocks = blocks.map(block => ({
                block_heading: block.block_heading || "",
                block_paragraph: block.block_paragraph || "",
                existing_image: block.existing_image || "",
                removed: block.removed ? 1 : 0
            }));

            formData.append("blocks", JSON.stringify(cleanBlocks));

            /* ---------- BLOCK IMAGES ---------- */
            blocks.forEach((block, index) => {
                if (block.block_image) {
                    formData.append(`block_images[${index}]`, block.block_image);
                }
            });

            const res = await axios.post(
                `${baseAPIUrl}admin/life_at_tigps/add_edit_life_at_tigps_section`,
                formData,
                { withCredentials: true }
            );
            await fetchContent();
            setMessage(res.data.message);
            scrollToTop();
        } catch (err) {
            console.error(err);
            setMessage("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) return <p>Loading...</p>;
    return (
        <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0 text-dark">Beyond academics</h1>
                        </div>{/* /.col */}
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><a href="/admin/dashboard">Dashboard</a></li>
                                <li class="breadcrumb-item active">Life at TIGPS</li>
                                <li class="breadcrumb-item active">Beyond academics</li>
                            </ol>
                        </div>{/* /.col */}
                    </div>{/* /.row */}
                </div>{/* /.container-fluid */}
            </div>
            {/* /.content-header */}
            {/* Main content */}
            <section className="content">
                <div className="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                {/*-- /.card-header --*/}
                                <div class="card-header">
                                    <h4>Edit Beyond academics</h4>
                                </div>
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    <div class="card-body">
                                        {message && (
                                            <p className="text-center text-danger">{message}</p>
                                        )}
                                        {/* SECTION */}
                                        <div className="form-group">
                                            <label>Main Heading</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={form.heading}
                                                placeholder="Heading"
                                                onChange={e => setForm({ ...form, heading: e.target.value })}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Intro Paragraph</label>
                                            <textarea
                                                className="form-control"
                                                rows="4"
                                                value={form.intro_paragraph}
                                                placeholder="Intro"
                                                onChange={e => setForm({ ...form, intro_paragraph: e.target.value })}
                                            />
                                        </div>

                                        <hr />

                                        {/* BLOCKS */}
                                        <h5>Cards</h5>

                                        {blocks.map((block, index) => (
                                            !block.removed && (
                                                <div key={index} className="border p-3 mb-3">

                                                    <div className="form-group">
                                                        <label>Card heading</label>
                                                        <input
                                                            type="text"
                                                            placeholder="Block heading"
                                                            className="form-control"
                                                            value={block.block_heading}
                                                            onChange={e => updateBlockHeading(index, e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label>Card text</label>
                                                        <textarea
                                                            placeholder="Block text"
                                                            className="form-control"
                                                            rows={6}
                                                            value={block.block_paragraph}
                                                            onChange={e => updateBlockParagraph(index, e.target.value)}
                                                        />
                                                    </div>

                                                    <div className="form-group">
                                                        <label>Card Image</label>
                                                        <input
                                                            type="file"
                                                            className="form-control"
                                                            accept="image/*"
                                                            onChange={e => updateBlockImage(index, e.target.files[0])}
                                                        />
                                                    </div>

                                                    {block.block_image_previw && (
                                                        <div className="mb-2">
                                                            <img
                                                                src={block.block_image_previw}
                                                                alt="preview"
                                                                style={{ width: "120px", display: "block" }}
                                                                className="img-bordered"
                                                            />
                                                        </div>
                                                    )}

                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="btn btn-danger"
                                                            onClick={() => removeBlock(index)}
                                                            disabled={blocks.length <= 1}
                                                        >
                                                            Remove Card
                                                        </button>
                                                    </div>

                                                </div>
                                            )
                                        ))}

                                        <button
                                            type="button"
                                            className="btn btn-success"
                                            onClick={addBlock}
                                        >
                                            + Add Card
                                        </button>

                                        <br /><br />

                                        <button type="submit" className="btn btn-primary">
                                            Save Section
                                        </button>
                                    </div>  
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div >
    )
}
export default LifeAtTIGPSSection;